import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableRow, Typography, useTheme } from "@mui/material";
import { CarriageWayEnum, ILuminaireLayoutConfig, IRoadLayoutConfig, IRoadwayConfig } from "types";
import { getLuminaireLayoutImage, LuminaireLayoutType } from "utils/images";
import getStyles from "./styles";

type Props = {
  roadwayConfig: IRoadwayConfig;
  roadLayoutConfig: IRoadLayoutConfig;
  luminaireLayoutConfig: ILuminaireLayoutConfig;
};

const RoadwayInfo: FC<Props> = ({ roadwayConfig, roadLayoutConfig, luminaireLayoutConfig }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const styles = useMemo(() => getStyles(theme).RoadwayInfo, [theme]);

  const carriageway = roadLayoutConfig.carriageWay === "SingleCarriageway" ? "single" : "double";
  const position = luminaireLayoutConfig.luminaireConfig.toLowerCase();

  return (
    <Box sx={styles.container}>
      <Typography variant="h2" sx={styles.title}>
        {t("Roadway Info")}
      </Typography>
      <TableContainer component={Paper} sx={styles.card}>
        <Box component="img" src={getLuminaireLayoutImage(carriageway, position as LuminaireLayoutType, roadLayoutConfig)} sx={styles.image} />

        <Table padding="none" sx={styles.table}>
          <TableBody>
            <TableRow>
              <TableCell>{t("Road Width")}</TableCell>
              <TableCell>{roadwayConfig.roadWidth} m</TableCell>
            </TableRow>

            {roadLayoutConfig.carriageWay !== CarriageWayEnum.SINGLE && (
              <TableRow>
                <TableCell>{t("Width Of Central Reservation")}</TableCell>
                <TableCell>{roadwayConfig.widthOfCentralReservation} m</TableCell>
              </TableRow>
            )}

            <TableRow>
              <TableCell>{t("Number Of Lanes")}</TableCell>
              <TableCell>{roadwayConfig.numberOfLanes}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell>{t("Covering")}</TableCell>
              <TableCell>
                {roadwayConfig.covering}, q0 = {roadwayConfig.q0}
              </TableCell>
            </TableRow>

            {roadwayConfig.borderAreaLeftWidth && roadLayoutConfig.borderAreaLeft && (
              <TableRow>
                <TableCell>{t("Border Area L Width")}</TableCell>
                <TableCell>{roadwayConfig.borderAreaLeftWidth} m </TableCell>
              </TableRow>
            )}

            {roadLayoutConfig.borderAreaLeft && (
              <TableRow>
                <TableCell>{t("Kerb distance left")}</TableCell>
                <TableCell>{roadwayConfig.borderAreaLeftKerbDistance} m </TableCell>
              </TableRow>
            )}

            {roadwayConfig.borderAreaRightWidth && roadLayoutConfig.borderAreaRight && (
              <TableRow>
                <TableCell>{t("Border Area R Width")}</TableCell>
                <TableCell>{roadwayConfig.borderAreaRightWidth} m </TableCell>
              </TableRow>
            )}

            {roadLayoutConfig.borderAreaRight && (
              <TableRow>
                <TableCell>{t("Kerb distance right")}</TableCell>
                <TableCell>{roadwayConfig.borderAreaRightKerbDistance} m </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default RoadwayInfo;
